<template>
  <Row>
    <Col span="24">
    <Card>
      <p slot="title">角色列表</p>
      <span slot="extra">
        <Select v-model="status" style="width:80px" @on-change="fetchData" placeholder="状态" clearable>
          <Option v-for="(status,key) in statuses" :value="key" :key="key">{{ status }}</Option>
        </Select>
        <Button type="success" @click="showAdd = true"><Icon type="md-add-circle"></Icon> 添加角色</Button>
      </span>
      <Row>
        <Col span="6" v-for="role in roles" :key="role.id" style="padding: 5px;">
          <role-item ref="roleItem" :model="role" @refresh="refresh" @edit="edit">
          </role-item>
        </Col>
      </Row>
      <pagination v-bind:meta="pageMeta" name="pagination" @refresh="fetchData"></pagination>
    </Card>
    <Modal
        v-model="showAdd"
        title="添加角色"
        :styles="{bottom:'0px'}" >
        <add-role ref="addRole" @refresh="refresh"></add-role>
        <div slot="footer" v-show="false"></div>
    </Modal>
    <Modal
        v-model="showEdit"
        title="编辑角色信息"
        :styles="{bottom:'0px'}" >
        <edit-role ref="editRole" :meta="meta" @refresh="refresh"></edit-role>
        <div slot="footer" v-show="false"></div>
    </Modal>
    </Col>
  </Row>
</template>

<script>
import { ListRoles, DeleteRole, GetAssistItems } from '@/api/auth'
import AddRole from '@/components/auth/AddRole'
import EditRole from '@/components/auth/EditRole'
import Pagination from '@/components/share/Pagination'
import RoleItem from '@/components/auth/RoleItem'

export default {
  name: 'list-roles',
  data: function () {
    return {
      roles: [],
      meta: '',
      showAdd: false,
      showEdit: false,
      pageMeta: {},
      status: '1',
      statuses: {}
    }
  },
  components: {
    'pagination': Pagination,
    'add-role': AddRole,
    'edit-role': EditRole,
    'role-item': RoleItem
  },
  created: function () {
    this.fetchData()
    this.getItems()
  },
  methods: {
    fetchData: function (page = 1) {
      var query = this.$router.currentRoute.query
      query['page'] = page
      query['RoleSearch[status]'] = this.status
      ListRoles(query).then(async res => {
        this.roles = res.items
        this.pageMeta = res._meta
      })
    },
    getItems: function () {
      GetAssistItems().then(async res => {
        this.statuses = res.statuses
      })
    },
    refresh: function () {
      this.fetchData()
      this.showAdd = false
      this.showEdit = false
    },
    edit: function (item) {
      this.meta = item
      this.$refs.editRole.init(item)
      this.showEdit = true
    },
    remove: function (item) {
      DeleteRole(item).then(async res => {
        this.refresh()
      })
    }
  }
}
</script>
